import { Button } from "@components/common";
import getProductDefaultConfiguration from "@helpers/products/getProductDefaultConfiguration";
import { addToCart, closeCart } from "@store/cart";
import { Item } from "@typings/product/item";
import { Link } from "gatsby";
import posthog from "posthog-js";
import React, { useMemo } from "react";
import { useDispatch } from "react-redux";

interface UpsellCartItemProps {
  item: Item;
}

const UpsellCartItem = ({ item }: UpsellCartItemProps) => {
  const product = useMemo(
    () => ({
      item,
      configuration: getProductDefaultConfiguration(item),
    }),
    [item]
  );
  const { configuration } = product;

  const dispatch = useDispatch();

  const handleAddToCart = () => {
    dispatch(addToCart({ cartItems: [product] }));

    if (typeof window !== "undefined") {
      posthog.capture("Add to cart", {
        product_id: item.id,
        product_name: item.name,
      });
    }
  };

  const handleCloseCart = () => {
    dispatch(closeCart());
  };

  return (
    <div className="cart-body-upsell-item">
      <div className="cart-body-upsell-item-block">
        <Link
          to={`/shop/${item.information?.slug}`}
          className="cart-body-upsell-link"
          onClick={handleCloseCart}
        >
          <div className="cart-body-upsell-item-img">
            <img src={item.information?.images.main || item.mainImage} alt={item.name} />
          </div>
        </Link>
        <div className="cart-body-upsell-item-content">
          <Link
            to={`/shop/${item.information?.slug}`}
            className="cart-body-upsell-link"
            onClick={handleCloseCart}
          >
            <span className="cart-body-upsell-item-content-name">{item.name}</span>
            <div>
              <span className="cart-body-upsell-item-content-price">${configuration.price}</span>
              <span className="cart-body-upsell-item-content-oldprice">
                ${configuration.oldPrice}
              </span>
            </div>
          </Link>
          <Button
            icon="arrow-right"
            color="white"
            onClick={handleAddToCart}
            className="cart-body-upsell-item-content-button"
          >
            Add
          </Button>
        </div>
      </div>

      <Button
        icon="arrow-right"
        color="white"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          handleAddToCart();
        }}
        className="cart-body-upsell-item-content-button-mobile"
      >
        Add
      </Button>
    </div>
  );
};

export default UpsellCartItem;
